import React, { useEffect, useMemo, useState } from "react";
import { Formik, Form, Field, FieldArray, getIn } from "formik";
import { Link, useLocation, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSlash, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getDdOptionForUI } from "../../store/reducer/ddOption/ddOptionSlice";
import { getOpportunityById } from "../../store/reducer/opportunity/opportunitySlice";

import {
  deleteBomItem,
  generateBom,
  getBomByDrawingId,
  getGenerateBomStatus,
  updateDrawingBom,
} from "../../store/reducer/drawing/drawingBomSlice";
import {
  getItemById,
  getItemsForUi,
} from "../../store/reducer/items/itemSlice";
import { getItemPriceByItemId } from "../../store/reducer/itemPrices/itemPriceSlice";
import { getDrawingById, getDrawingLockStatus } from "../../store/reducer/drawing/drawingSlice";
import Notes from "../Notes/Notes";
import { proposalStatusByDrawingId } from "../../store/reducer/drawing/drawingProposalSlice";
import {  getProposalFinalStatus } from "../../store/reducer/drawing/drawingFileSilce";
import { deletePandLOnChange } from "../../store/reducer/drawing/drawingPandLSlice";
import { deleteInstallOnChange } from "../../store/reducer/drawing/drawingInstallSlice";
import { deleteProposalOnChange } from "../../store/reducer/drawing/drawingFileSilce";
import DrawingTabs from "./DrawingTabs";

function EditDrawingBom() {
  const { id, drawing_id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();

  const [opportunityData, setOpportunityData] = useState([]);
  const [drawingData, setdrawingData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [bomData, setBomData] = useState([]);
  const [proposalStatus, setProposalStatus] = useState(true);
  const [selectedItemPrice, setSelectedItemPrice] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);
  const [isProposalFinalised, setIsProposalFinalised] = useState(false);
  const [isDrawingLocked, setIsDrawingLocked] = useState(false);
  const [itemType, setItemType] = useState(""); // integer
  const [search, setSearch] = useState("");     // string

  const { items = [] } = useSelector((state) => state.items);


  const { options = [] } = useSelector((state) => state.ddOptions);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const ErrorMessage = ({ name }) => (
    <Field
      name={name}
      render={({ form }) => {
        const error = getIn(form.errors, name);
        const touch = getIn(form.touched, name);
        return touch && error ? (
          <div className="text-red-700">{error}</div>
        ) : null;
      }}
    />
  );

  useEffect(() => {
    dispatch(getDdOptionForUI());
    dispatch(getDrawingLockStatus(drawing_id)).then(result => {
      if(result?.payload?.locked) {
        setIsDrawingLocked(result.payload.locked);
      }
    });
    dispatch(getProposalFinalStatus(drawing_id)).then(result => {
      if(result?.payload?.isProposalFinalised) {
        setIsProposalFinalised(true);
      }
    })
    dispatch(getOpportunityById(id)).then((result) => {
      if (result.payload) {
        setOpportunityData(result.payload);
      }
    });
    dispatch(getDrawingById(drawing_id)).then((result) => {
      if (result.payload) {
        setdrawingData(result.payload);

        dispatch(proposalStatusByDrawingId(result.payload.uniqueId)).then(
          (result) => {
            if (result.payload) {
              setProposalStatus(result.payload.hasData);
            } else {
              setProposalStatus(false);
            }
          }
        );
      }
    });

    dispatch(getItemsForUi());

    dispatch(getBomByDrawingId({ drawing_id })).then((result) => {
      if (result.payload) {
        setBomData(result.payload);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  }, []);

  const handleGenerateBom = () => {
    setLoading(true);
    dispatch(generateBom(drawing_id)).then((result) => {
      if (result.payload) {
        dispatch(proposalStatusByDrawingId(drawingData.drawing_uniqueId)).then(
          (result) => {
            if (result.payload) {
              setProposalStatus(result.payload.hasData);
            } else {
              setProposalStatus(result.payload.hasData);
            }
          }
        );
        dispatch(getBomByDrawingId({ drawing_id })).then((result) => {
          if (result.payload) {
            setBomData(result.payload);
            setLoading(false);
          }
        });
        toast.success(result.payload.message);
      } else {
        toast.error(result.error.message);
      }
    });
  };

  const validationSchema = Yup.object().shape({
    bom_items: Yup.array()
      .of(
        Yup.object().shape({
          item_id: Yup.string().required("please select item"),
          qty: Yup.number().required("required").integer(),
          item_length: Yup.number().required("required").positive("positive"),
          revised_qty: Yup.number("must be number")
            .required("required")
            .positive("must be positive number"),
        })
      )
      .required("Must have area"),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      setSubmitting(true);
      values.drawing_id = drawing_id;
      values.drawing_uniqueId = drawingData.uniqueId;
      values.createdBy = JSON.parse(localStorage.getItem("userSession")).id;
  
      const hasItemChanged = (originalItem, updatedItem) => {
        return Object.keys(updatedItem).some((key) => {
          if (key === "updatedAt") return false;
  
          const originalValue = originalItem?.[key] ?? "";
          const updatedValue = updatedItem?.[key] ?? "";
  
          if (typeof originalValue === "object" || typeof updatedValue === "object") {
            return JSON.stringify(originalValue) !== JSON.stringify(updatedValue);
          }
  
          return originalValue !== updatedValue;
        });
      };
  
      // Compare and update UPDATE_FLAG
      const updatedBomItems = values.bom_items.map((item, index) => {
        const originalItem = bomData[activeTab]?.bom_items?.[index];
        const isChanged = originalItem ? hasItemChanged(originalItem, item) : false;
  
        return {
          ...item,
          UPDATE_FLAG: isChanged ? 1 : item.UPDATE_FLAG || 0,
        };
      });
  
      values.bom_items = updatedBomItems;
  
      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => {
        formData.append(key, key === "bom_items" ? JSON.stringify(value) : value);
      });
  
      // Execute all delete operations in parallel
      const deleteResults = await Promise.all([
        dispatch(deletePandLOnChange(drawing_id)),
        dispatch(deleteInstallOnChange(drawing_id)),
        dispatch(deleteProposalOnChange(drawing_id)),
      ]);
  
      if (deleteResults.some((res) => !res.payload)) {
        toast.error("Failed to delete related data.");
        setSubmitting(false);
        return;
      }
  
      // Update BOM Data
      const updateResult = await dispatch(updateDrawingBom({ data: formData, drawing_id }));
      if (updateResult.payload) {
        toast.success(updateResult.payload.message);
        const bomDataResult = await dispatch(getBomByDrawingId({ drawing_id }));
        if (bomDataResult.payload) {
          setBomData(bomDataResult.payload);
        }
      } else {
        toast.error(updateResult.error?.message || "Failed to update BOM");
      }
    } catch (error) {
      console.error("Error updating BOM:", error);
      toast.error("An unexpected error occurred");
    } finally {
      setSubmitting(false);
    }
  };
  
  const handleDeleteItem = async (id) => {
    // Wait for the delete action to complete
    let deleteResult = await dispatch(deletePandLOnChange(drawing_id));
    if (!deleteResult.payload) {
      toast.error("Failed to delete pandl data.");
      return;
    }
    
    deleteResult = await dispatch(deleteInstallOnChange(drawing_id));
    if (!deleteResult.payload) {
      toast.error("Failed to delete install data.");
      return;
    }
  
    deleteResult = await dispatch(deleteProposalOnChange(drawing_id));
    if (!deleteResult.payload) {
      toast.error("Failed to delete proposal data.");
      return;
    }
    
    await dispatch(deleteBomItem({ id })).then((result) => {
      if (result.payload) {
        dispatch(getBomByDrawingId({ drawing_id })).then((result) => {
          if (result.payload) {
            setBomData(result.payload);
          }
        });
        toast.success(result.payload.message);
      } else {
        toast.error(result.error.message);
      }
    });
  };

  return (
    <>
      <div className="block md:grid grid-cols-3 items-center mb-[30px]">
        <div className="flex gap-[16px] items-center mb-[32px] md:mb-0">
          <Link to={`/opportunity/${id}`}>
            <div className="bg-[#F8F8F8] rounded-[10px] p-[8px]">
              <img
                className="w-[24px]"
                src={process.env.PUBLIC_URL + "/icons/back.png"}
                alt="back icon"
              />
            </div>
          </Link>
          <div className="flex flex-col">
            <span className="font-Inter font-[400] leading-[16px] text-[#9E9E9E] text-[14px]">
              Drawing BOM / Edit
            </span>
            <span className="font-Inter font-[700] leading-[30px] text-[24px]">
              BOM
            </span>
          </div>
        </div>
        <div className="font-Inter font-[500] leading-[30px] text-[18px] text-center">
          {opportunityData.id}-{drawing_id}-{opportunityData.opportunity_name}
        </div>
        <Notes type="drawing-boms" drawing_id={drawing_id} />
      </div>
      <DrawingTabs />
      {!loading ? (
        <>
          <div className="border border-gray-200 p-4 rounded-lg">
            <div className="grid grid-cols-5 gap-[20px] justify-between mb-2">
              <div className="col-span-4">
                <div className="flex gap-[30px] p-2 text-nowrap overflow-x-scroll">
                  {bomData.length ? (
                    bomData.map((bom, index) => {
                      return (
                        <span
                          className={`flex justify-center border-b-4 py-2 px-5 cursor-pointer ${
                            activeTab === index
                              ? "text-[#55A14A] border-b-4 border-[#55A14A]"
                              : "text-black border-transparent hover:border-b-4 hover:border-[#55A14A] hover:text-[#55A14A]"
                          }`}
                          key={index}
                          onClick={() => handleTabClick(index)}
                          data_id={index}
                        >
                          {bom.area_name}
                        </span>
                      );
                    })
                  ) : (
                    <FontAwesomeIcon icon={faSpinner} spin />
                  )}
                </div>
              </div>
              {!proposalStatus && !isProposalFinalised && !isDrawingLocked && (
                <div className="grid-cols-1">
                  <button onClick={handleGenerateBom}>
                    <div className="py-[10px] px-[40px] font-[500] font-Inter text-[18px] text-center text-[#17171B] rounded-[12px] text-[#55A14A] border border-[#55A14A]">
                      <span>Generate BOM</span>
                    </div>
                  </button>
                </div>
              )}
            </div>
            <div className="flex gap-4 mb-4">
              <input
                type="text"
                placeholder="Search item description"
                className="border rounded px-3 py-2 w-[300px]"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              <select
                className="border rounded px-3 py-2"
                value={itemType}
                onChange={(e) => setItemType(e.target.value)}
              >
                <option value="">Select Item Type</option>
                {options
                  .filter(
                    (option) =>
                      option.ui_name === "Item" &&
                      option.field_name === "Item Type"
                  )
                  .sort((a, b) => a.sort_field - b.sort_field)
                  .map((option) => (
                    <option value={option.id}>
                      {option.field_code}
                    </option>
                  ))}
              </select>

              <button
                className="bg-[#55A14A] text-white px-4 py-2 rounded"
                onClick={() => {
                  setLoading(true);
                  dispatch(
                    getBomByDrawingId({
                      drawing_id,
                      item_type: itemType,
                      search,
                    })
                  ).then((result) => {
                    if (result.payload) setBomData(result.payload);
                    setLoading(false);
                  });
                }}
              >
                Apply
              </button>
            </div>

            {bomData.length ? (
              bomData
                .filter((bom, index) => index === activeTab)
                .map((bom, index) => {
                  let initialValues = {
                    area_id: `${bom.area_id}`,
                    area_uniqueId: `${bom.area_uniqueId}`,
                    area_name: `${bom.area_name}`,
                    bom_items: bom.bom_items.length
                      ? bom.bom_items
                      : [
                          {
                            id: "",
                            uniqueId: "",
                            item_id: "",
                            extra_details: "",
                            qty: "",
                            item_length: "",
                            revised_qty: "",
                            item_cost: "",
                            total_line_cost: "",
                            bom_supplier_id: "",
                            item_price: "",
                            total_line_price: "",
                            price_factor: "",
                            UPDATE_FLAG: 0,
                            uom: ""
                          },
                        ],
                  };
                  return (
                    <Formik
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      onSubmit={handleSubmit}
                      key={bom.area_id}
                    >
                      {({
                        isSubmitting,
                        values,
                        errors,
                        touched,
                        setFieldValue,
                        handleSubmit,
                      }) => (
                        <Form>
                          <FieldArray name="bom_items">
                            {({ insert, remove, push }) => {
                              const bomItemsIdSet = new Set(
                                values?.bom_items?.map(
                                  ({ item_id }) => +item_id
                                ) || []
                              );

                              return (
                                <div>
                                <div className="relative max-h-[70vh] overflow-auto">
                                    <div className="sm:rounded-lg mt-5 w-full min-w-[2000px]">
                                      <div className="grid grid-cols-12 gap-[20px] bg-[#F8F8F8] sticky top-0 z-20">
                                        <div className="col-span-3 px-2 py-3 text-center font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider ">
                                          Item name
                                        </div>
                                        <div className="px-2 py-3 col-span-2 text-center font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap">
                                          Extra Details
                                        </div>
                                        <div className="flex  gap-[20px] col-span-3  justify-evenly">
                                          <div className="px-2 py-3 text-center font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap">
                                            Quantity
                                          </div>
                                          <div className="px-2 py-3 text-center font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap">
                                            Length
                                          </div>
                                          <div className="px-2 py-3 text-center font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap">
                                            Total Qty
                                          </div>
                                          <div className="px-2 py-3 text-center font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap">
                                            Cost
                                          </div>
                                        </div>
                                        <div className="flex gap-[20px] col-span-3  justify-evenly">
                                          <div className="px-2 py-3 text-center font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap">
                                            Line Cost 
                                            <p>({new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(
                                              values?.bom_items?.reduce((acc, it) => acc + (Number(it.total_line_cost) || 0), 0)
                                            )})</p>
                                          </div>
                                          <div className="px-2 py-3 text-center font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap">
                                            Item Price
                                          </div>
                                          <div className="px-2 py-3 text-center font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap">
                                            Line Price
                                            <p>({new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(
                                              values?.bom_items?.reduce((acc, it) => acc + (Number(it.total_line_price) || 0), 0)
                                            )})</p>
                                          </div>
                                          <div className="px-2 py-3 text-center font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap">
                                            Options
                                          </div>
                                        </div>
                                      </div>
                                      {values.bom_items.length > 0 &&
                                        values.bom_items.map((bom, index) => {
                                          return (
                                            <div
                                              className="grid grid-cols-12 gap-[20px] mt-5 p-1"
                                              key={index}
                                              style={{
                                                backgroundColor: bom.total_line_cost == 0 ? '#ffcccc' : 'transparent' // Light red
                                              }}                                                                                         
                                            >
                                              <div className="col-span-3">
                                                <div className="relative">
                                                  <Field
                                                    as="select"
                                                    className="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded-[12px] leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                    id={`bom_items.${index}.item_id`}
                                                    name={`bom_items.${index}.item_id`}
                                                    disabled={bom.uniqueId}
                                                    onChange={(e) => {
                                                      setFieldValue(
                                                        `bom_items.${index}.item_id`,
                                                        e.target.value
                                                      );
                                                      // setFieldValue(
                                                      //   `bom_items.${index}.price_factor`,
                                                      //   parseFloat(
                                                      //     values.price_factor
                                                      //   )
                                                      // );
                                                      dispatch(
                                                        getItemById(
                                                          e.target.value
                                                        )
                                                      ).then((result) => {
                                                        if (result.payload) {
                                                          setSelectedItem(
                                                            result.payload
                                                          );
                                                          setFieldValue(
                                                            `bom_items.${index}.price_factor`,
                                                            parseFloat(
                                                              result.payload
                                                                .price_factor
                                                            )
                                                          );
                                                          const items =
                                                            result.payload;
                                                          setFieldValue(
                                                            `bom_items.${index}.item_length`,
                                                            result.payload
                                                              .length_of_material ||
                                                              0
                                                          );
                                                          setFieldValue(`bom_items.${index}.UOM`, result.payload.uom || "");
                                                          setFieldValue(
                                                            `bom_items.${index}.bom_supplier_id`,
                                                            3
                                                          );
                                                          dispatch(
                                                            getItemPriceByItemId(
                                                              e.target.value
                                                            )
                                                          ).then((result) => {
                                                            if (
                                                              result.payload
                                                            ) {
                                                              if (
                                                                result.payload
                                                                  .unit_price ===
                                                                0
                                                              ) {
                                                                toast.error(
                                                                  "Price is zero"
                                                                );
                                                              }
                                                              setSelectedItemPrice(
                                                                result.payload
                                                              );
                                                              setFieldValue(
                                                                `bom_items.${index}.item_cost`,
                                                                (
                                                                  Math.round(
                                                                    result
                                                                      .payload
                                                                      .unit_price *
                                                                      100
                                                                  ) / 100
                                                                ).toFixed(2)
                                                              );

                                                              let item_price = (
                                                                Math.round(
                                                                  result.payload
                                                                    .unit_price *
                                                                    parseFloat(
                                                                      items.price_factor
                                                                    ) *
                                                                    100
                                                                ) / 100
                                                              ).toFixed(2);
                                                              setFieldValue(
                                                                `bom_items.${index}.item_price`,
                                                                item_price
                                                              );
                                                            } else {
                                                              toast.error(
                                                                "Price not found"
                                                              );
                                                            }
                                                          });
                                                        } else {
                                                          toast.error(
                                                            "Item not found"
                                                          );
                                                        }
                                                      });
                                                    }}
                                                  >
                                                    <option value={""}>
                                                      Select Item
                                                    </option>
                                                    {items
                                                      .filter(
                                                        ({ group_id, id }) =>
                                                          (group_id === 425 ||
                                                            group_id === 427 ||
                                                            group_id === 528 ||
                                                            group_id === 429 ||
                                                            group_id === 430 ||
                                                            group_id === 431 ||
                                                            group_id === 432 ||
                                                            group_id === 433 ||
                                                            group_id === 434 ||
                                                            group_id === 436 ||
                                                            group_id === 438) &&
                                                          (bom.item_id ||
                                                            !bomItemsIdSet.has(
                                                              +id
                                                            ))
                                                      )
                                                      .map((item) => (
                                                        <option
                                                          value={item.id}
                                                          key={item.id}
                                                        >
                                                          {
                                                            item.item_description
                                                          }
                                                        </option>
                                                      ))}
                                                  </Field>
                                                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                    <svg
                                                      className="fill-current h-4 w-4"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      viewBox="0 0 20 20"
                                                    >
                                                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                                    </svg>
                                                  </div>
                                                </div>
                                                <ErrorMessage
                                                  name={`bom_items.${index}.item_id`}
                                                />
                                              </div>
                                              <div className="col-span-2">
                                                <Field
                                                  className="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-3 px-2 rounded-[12px] leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-center"
                                                  id={`bom_items.${index}.extra_details`}
                                                  name={`bom_items.${index}.extra_details`}
                                                ></Field>
                                                <ErrorMessage
                                                  name={`bom_items.${index}.extra_details`}
                                                />
                                              </div>
                                              <div className="flex gap-[20px] col-span-3">
                                                <div>
                                                  <Field
                                                    className="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-3 px-2 rounded-[12px] leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-center"
                                                    id={`bom_items.${index}.qty`}
                                                    name={`bom_items.${index}.qty`}
                                                    onChange={(e) => {
                                                      let qty = e.target.value;
                                                      setFieldValue(
                                                        `bom_items.${index}.qty`,
                                                        e.target.value
                                                      );

                                                      let itemCost = parseFloat(
                                                        values.bom_items[index]
                                                          .item_cost || 0
                                                      );
                                                      let itemPrice =
                                                        parseFloat(
                                                          values.bom_items[
                                                            index
                                                          ].item_price || 0
                                                        );

                                                      let result = items.filter(
                                                        (item) =>
                                                          item.id ===
                                                          parseInt(
                                                            values.bom_items[
                                                              index
                                                            ].item_id,
                                                            10
                                                          )
                                                      );
                                                      if (
                                                        result[0].uom === 442
                                                      ) {
                                                        let itemLength =
                                                          parseFloat(
                                                            values.bom_items[
                                                              index
                                                            ].item_length || 0
                                                          );
                                                        let revQty = parseFloat(
                                                          qty * itemLength
                                                        ).toFixed(2);
                                                        setFieldValue(
                                                          `bom_items.${index}.revised_qty`,
                                                          revQty
                                                        );

                                                        let totalLineCost =
                                                          parseFloat(
                                                            revQty * itemCost
                                                          ).toFixed(2);

                                                        let totalLinePrice =
                                                          parseFloat(
                                                            revQty * itemPrice
                                                          ).toFixed(2);

                                                        setFieldValue(
                                                          `bom_items.${index}.total_line_cost`,
                                                          totalLineCost
                                                        );
                                                        setFieldValue(
                                                          `bom_items.${index}.total_line_price`,
                                                          totalLinePrice
                                                        );
                                                      } else {
                                                        let revQty = qty;
                                                        setFieldValue(
                                                          `bom_items.${index}.revised_qty`,
                                                          revQty
                                                        );

                                                        let totalLineCost =
                                                          parseFloat(
                                                            revQty * itemCost
                                                          ).toFixed(2);

                                                        let totalLinePrice =
                                                          parseFloat(
                                                            revQty * itemPrice
                                                          ).toFixed(2);

                                                        setFieldValue(
                                                          `bom_items.${index}.total_line_cost`,
                                                          totalLineCost
                                                        );
                                                        setFieldValue(
                                                          `bom_items.${index}.total_line_price`,
                                                          totalLinePrice
                                                        );
                                                      }
                                                    }}
                                                  ></Field>
                                                  <ErrorMessage
                                                    name={`bom_items.${index}.qty`}
                                                  />
                                                </div>
                                                <div>
                                                  <Field
                                                    className="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-3 px-2 rounded-[12px] leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-center"
                                                    id={`bom_items.${index}.item_length`}
                                                    name={`bom_items.${index}.item_length`}
                                                    onChange={(e) => {
                                                      const itemLength =
                                                        e.target.value;
                                                      setFieldValue(
                                                        `bom_items.${index}.item_length`,
                                                        e.target.value
                                                      );
                                                      const qty = parseFloat(
                                                        values.bom_items[index]
                                                          .qty || 0
                                                      );
                                                      const itemCost =
                                                        parseFloat(
                                                          values.bom_items[
                                                            index
                                                          ].item_cost || 0
                                                        );
                                                      const itemPrice =
                                                        parseFloat(
                                                          values.bom_items[
                                                            index
                                                          ].item_price || 0
                                                        );

                                                      let result = items.filter(
                                                        (item) =>
                                                          item.id ===
                                                          parseInt(
                                                            values.bom_items[
                                                              index
                                                            ].item_id,
                                                            10
                                                          )
                                                      );
                                                      if (
                                                        result[0].uom === 442
                                                      ) {
                                                        let revQty = (
                                                          parseFloat(qty || 0) *
                                                          itemLength
                                                        ).toFixed(2);

                                                        setFieldValue(
                                                          `bom_items.${index}.revised_qty`,
                                                          revQty
                                                        );

                                                        let totalLineCost = (
                                                          parseFloat(revQty) *
                                                          itemCost
                                                        ).toFixed(2);

                                                        let totalLinePrice = (
                                                          parseFloat(revQty) *
                                                          itemPrice
                                                        ).toFixed(2);

                                                        setFieldValue(
                                                          `bom_items.${index}.total_line_cost`,
                                                          totalLineCost
                                                        );
                                                        setFieldValue(
                                                          `bom_items.${index}.total_line_price`,
                                                          totalLinePrice
                                                        );
                                                      } else {
                                                        let revQty = parseFloat(
                                                          qty || 0
                                                        ).toFixed(2);

                                                        setFieldValue(
                                                          `bom_items.${index}.revised_qty`,
                                                          revQty
                                                        );

                                                        const itemCost =
                                                          parseFloat(
                                                            values.bom_items[
                                                              index
                                                            ].item_cost || 0
                                                          );
                                                        const itemPrice =
                                                          parseFloat(
                                                            values.bom_items[
                                                              index
                                                            ].item_price || 0
                                                          );

                                                        const totalLineCost = (
                                                          parseFloat(
                                                            values.bom_items[
                                                              index
                                                            ].revised_qty
                                                          ) * itemCost
                                                        ).toFixed(2);

                                                        const totalLinePrice = (
                                                          parseFloat(
                                                            values.bom_items[
                                                              index
                                                            ].revised_qty
                                                          ) * itemPrice
                                                        ).toFixed(2);

                                                        setFieldValue(
                                                          `bom_items.${index}.total_line_cost`,
                                                          totalLineCost
                                                        );
                                                        setFieldValue(
                                                          `bom_items.${index}.total_line_price`,
                                                          totalLinePrice
                                                        );
                                                      }
                                                    }}
                                                  ></Field>
                                                  <ErrorMessage
                                                    name={`bom_items.${index}.item_length`}
                                                  />
                                                </div>

                                                <div>
                                                  <Field
                                                    className="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-3 px-2 rounded-[12px] leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-center"
                                                    id={`bom_items.${index}.revised_qty`}
                                                    name={`bom_items.${index}.revised_qty`}
                                                    disabled
                                                    onChange={(e) => {
                                                      const revisedQty =
                                                        e.target.value;
                                                      setFieldValue(
                                                        `bom_items.${index}.revised_qty`,
                                                        revisedQty
                                                      );
                                                    }}
                                                  ></Field>
                                                  <ErrorMessage
                                                    name={`bom_items.${index}.revised_qty`}
                                                  />
                                                </div>

                                                <div>
                                                  <Field
                                                    className="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-3 px-2 rounded-[12px] leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-center"
                                                    id={`bom_items.${index}.item_cost`}
                                                    name={`bom_items.${index}.item_cost`}
                                                    onChange={(e) => {
                                                      const itemCost =
                                                        e.target.value;

                                                      setFieldValue(
                                                        `bom_items.${index}.item_cost`,
                                                        e.target.value
                                                      );
                                                      const revisedQty =
                                                        parseFloat(
                                                          values.bom_items[
                                                            index
                                                          ].revised_qty || 0
                                                        );
                                                      const itemPrice = (
                                                        parseFloat(
                                                          e.target.value || 0
                                                        ) *
                                                        values.bom_items[index]
                                                          .price_factor
                                                      ).toFixed(2);

                                                      const totalLineCost = (
                                                        parseFloat(
                                                          revisedQty || 0
                                                        ) * itemCost
                                                      ).toFixed(2);

                                                      const totalLinePrice = (
                                                        parseFloat(
                                                          revisedQty || 0
                                                        ) * itemPrice
                                                      ).toFixed(2);

                                                      setFieldValue(
                                                        `bom_items.${index}.item_price`,
                                                        itemPrice
                                                      );

                                                      setFieldValue(
                                                        `bom_items.${index}.total_line_cost`,
                                                        totalLineCost
                                                      );
                                                      setFieldValue(
                                                        `bom_items.${index}.total_line_price`,
                                                        totalLinePrice
                                                      );
                                                    }}
                                                  ></Field>
                                                </div>
                                              </div>
                                              <div className="flex gap-[20px] col-span-3">
                                                <div>
                                                  <Field
                                                    className="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-3 px-2 rounded-[12px] leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-center"
                                                    id={`bom_items.${index}.total_line_cost`}
                                                    name={`bom_items.${index}.total_line_cost`}
                                                    disabled
                                                  ></Field>
                                                </div>
                                                <div>
                                                  <Field
                                                    className="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-3 px-2 rounded-[12px] leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-center"
                                                    id={`bom_items.${index}.item_price`}
                                                    name={`bom_items.${index}.item_price`}
                                                    disabled
                                                  ></Field>
                                                </div>
                                                <div>
                                                  <Field
                                                    className="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-3 px-2 rounded-[12px] leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-center"
                                                    id={`bom_items.${index}.total_line_price`}
                                                    name={`bom_items.${index}.total_line_price`}
                                                    disabled
                                                  ></Field>
                                                </div>
                                                {values.bom_items.length >
                                                  1 && (
                                                  <div className="py-2 text-center">
                                                    {!isProposalFinalised && !isDrawingLocked && (
                                                      <span
                                                        className="text-red-400 hover:text-red-700 p-3 bg-white rounded-lg cursor-pointer"
                                                        onClick={() => {
                                                          if (
                                                            values.bom_items[
                                                              index
                                                            ].uniqueId
                                                          ) {
                                                            handleDeleteItem(
                                                              values.bom_items[
                                                                index
                                                              ].id
                                                            );
                                                          }
                                                          remove(index);
                                                        }}
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faTrash}
                                                          size="xl"
                                                        />
                                                      </span>
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        })}
                                    </div>
                                  </div>
                                  <div className="text-right p-[16px]">
                                    {!isProposalFinalised && !isDrawingLocked && (
                                      <span
                                        className="cursor-pointer text-[#55A14A]"
                                        onClick={() =>
                                          push({
                                            id: "",
                                            uniqueId: "",
                                            item_id: "",
                                            qty: "",
                                            item_length: "",
                                            revised_qty: "",
                                            item_cost: "",
                                            total_line_cost: "",
                                            bom_supplier_id: "",
                                            item_price: "",
                                            total_line_price: "",
                                            extra_details: "",
                                            uom: ""
                                          })
                                        }
                                      >
                                        + Add New Item
                                      </span>
                                    )}
                                  </div>
                                </div>
                              );
                            }}
                          </FieldArray>

                          {!isProposalFinalised && !isDrawingLocked && (
                            <div className="flex gap-[24px] bg-[#F8F8F8] rounded-[12px] mt-5 p-4">
                              <div>
                                <button
                                  type="submit"
                                  name="submit"
                                  className={`py-[12px] px-[48px] text-center text-white w-full rounded-[12px] text-[18px] ${
                                    isSubmitting || proposalStatus
                                      ? "bg-gray-300"
                                      : "bg-[#1C1C20]"
                                  }`}
                                  disabled={isSubmitting || proposalStatus}
                                >
                                  {isSubmitting ? (
                                    <FontAwesomeIcon icon={faSpinner} spin />
                                  ) : (
                                    "Save"
                                  )}
                                </button>
                              </div>
                            </div>
                          )}
                        </Form>
                      )}
                    </Formik>
                  );
                })
            ) : (
              <div className="text-center">
                <FontAwesomeIcon
                  icon={faSpinner}
                  size="2xl"
                  style={{ color: "#55A14A" }}
                  spin
                />
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="text-center">
            <div className="flex justify-center items-center h-[300px]">
              <FontAwesomeIcon
                icon={faSpinner}
                spin
                size="2xl"
                className="text-[#55A14A]"
              />
            </div>
        </div>
      )}
    </>
  );
}

export default EditDrawingBom;
